import React from "react";
import { Rating } from "react-simple-star-rating";
import "../../assets/css/Reviews.css";
import { review, client1, client2, client3 } from "../../constant";
import moment from "moment";
import { useSelector } from "react-redux";
import { ramdomImage } from "../../constant/ConstantFunction";

function AllReviews(props) {
	const { reviewData } = props;
	const ImageUrlRedux = useSelector((state) => state.AuthReducer.urlData)
	return (
		<>
			<div className="reviews_sec paas">
				<div className="heading">
					<h3>Reviews</h3>
				</div>
				{reviewData?.reviews?.map((item, index) => {
					return (
						<>
							{
								index < 6 ? (
									<>
										<div className="reviewDv" key={index}>
											<div className="questionDv reviews">
												<div className="user-img">
													<figure>
														{
															item?.user?.image == null ? (
																<img src={`${ramdomImage(
																	`${item?.user?.f_name} ${item?.user?.l_name}`
																)}`}
																	className="image-fluid image-width"
																	alt="" />
															) : (
																<img src={`${ImageUrlRedux?.customer_image_url}/${item?.user?.image}`} className="img-fluid" />
															)
														}
													</figure>
												</div>
												<div className="detailDv">
													<div className="header">
														<h5 className="name">
															{item?.user?.f_name} {item?.user?.l_name}{" "}
														</h5>
														<p>
															{" "}
															{moment(item?.created_at).format(
																"MMMM Do YYYY, h:mm a"
															)}
														</p>
													</div>
													<p>{item?.comment}</p>
													<div className="bottom-bar">
														<div className="rating rate_star_color_orng">
															<Rating
																size={18}
																readonly={true}
																allowFraction={true}
																initialValue={item?.rating}
															/>
														
															<p className="count">{item?.rating}</p>
														</div>
													
													</div>
												</div>
											</div>
											
										</div>
									</>
								) : (null)
							}
						</>
					);
				})}

		
			</div>
		</>
	);
}

export default AllReviews;
